<template id="headerAll">
    <van-nav-bar title="" left-text="返回" @click-left="backJump" left-arrow>
      <template #right>
        <van-icon name="ellipsis" />
      </template>
    </van-nav-bar>
</template>

<script>
export default {
  name: "header",
  components:{
    headerAll: {
      template:'#headerAll'
    }
  },
  methods:{
    backJump(){
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped>

</style>